<h1 style="margin: 0.5em">Fretboard Visualizer</h1>

<div class="note-options">
  <div class="option-group">
    <div class="title">Notes</div>

    <div class="options">
      <button class="toggle-all" (click)="toggleAll()">
        <i
          [ngClass]="{
            fas: (allNotesSelected$ | async),
            far: !(allNotesSelected$ | async)
          }"
          class="fas fa-check-circle"
        ></i>
      </button>
      <div class="note-option" *ngFor="let note of selectedNotes$ | async">
        <input
          class="hidden"
          (change)="selectionChanged(note)"
          [checked]="note.selected"
          type="checkbox"
          [name]="note.note"
          [id]="note.note"
        />
        <label
          [ngClass]="{
            selected: note.selected
          }"
          [for]="note.note"
          >{{ note.note }}</label
        >
      </div>
    </div>
  </div>

  <div class="option-group">
    <div class="title">Scales</div>

    <div class="options">
      <div class="selector">
        <label (click)="selectMode($event)">Scale / Mode</label>
        <div *ngIf="selectModeOpen$ | async" class="menu">
          <h2>Scale / Mode</h2>
          <ul>
            <li (click)="modeSelected('G Major')">G Ionian (Major)</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

<app-fretboard id="fretboard" [notes]="fretboardNotes$ | async"></app-fretboard>
<!-- <div id="player">Player</div> -->
